import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "form", "reasonField", "approveButton"]

  showForm() {
    this.buttonTarget.classList.add("hidden")
    if (this.hasApproveButtonTarget) {
      this.approveButtonTarget.classList.add("hidden")
    }
    this.formTarget.classList.remove("hidden")
    this.reasonFieldTarget.focus()
  }

  hideForm(event) {
    event.preventDefault()
    this.formTarget.classList.add("hidden")
    this.buttonTarget.classList.remove("hidden")
    if (this.hasApproveButtonTarget) {
      this.approveButtonTarget.classList.remove("hidden")
    }
    this.reasonFieldTarget.value = ""
  }
}

